<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-chip-group active-class="primary--text" column>
						<v-chip v-for="(favorit, index) in favorits" :key="index" 
							close
							@click:close="removeFavorit(favorit)"
							@click="onFavorit(favorit)"
						>
						{{ favorit.name }}
						</v-chip>
					</v-chip-group>
					<z-parameters ref="parameters"></z-parameters>

					<div v-if="isAdmin">
						<v-divider class="my-3"></v-divider>

						<v-textarea
							v-model="promptCustom"
							outlined
							label="Альтернативний промпт"
							dense
							hide-details="auto"
						></v-textarea>

						<v-divider class="my-3"></v-divider>
						
						<div class="text-caption font-weight-bold">Згенерований промпт:</div>
						<div class="text-caption">{{ prompt }}</div>
					</div>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right floating
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<!-- <v-list dense nav>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-bind="attrs" v-on="{ ...tooltip }" @click="onLoad">mdi-folder</v-icon>
							</template>
							<span>Завантажити</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-bind="attrs" v-on="{ ...tooltip }" @click="onSave">mdi-content-save</v-icon>
							</template>
							<span>Зберегти</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
			<v-divider></v-divider> -->
			<v-list dense nav>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
        </v-navigation-drawer>

        <v-container style="padding: 64px 0px 0px 256px;">
			<v-card flat>
				<v-card-title class="text-h5">{{ title }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>
				<v-divider></v-divider>
				<v-card-text v-html="item.outputHtml">
				</v-card-text>
			</v-card>
		</v-container>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-file-input
			v-model="filedata"
			ref="filedata"
			class="d-none"
			accept="application/json"
			@change="changeFileData"
		></v-file-input>

		<z-pdf ref="pdf" :item="pdf"></z-pdf>
    </v-main>
</template>

<script>
import axios from 'axios'
//import mixin from './mixin/main'
import mixin from './mixin/parameters'
import { mapGetters, mapActions } from 'vuex'
import zPdf from '@/views/pdf/VehicleEstimateAI'
//import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
//import zVehicleParameters from '@/views/forms/vehicle.parameters.showroom'
import zParameters from '@/views/forms/parameters/VehicleEstimateAI'

//import { GoogleGenAI } from "@google/genai";
//import DOMPurify from 'dompurify';
//import { marked } from "https://cdn.jsdelivr.net/npm/marked/lib/marked.esm.js";
//import { marked } from 'marked';
//import { markdownit } from 'markdown-it';
//import VueMarkdown from 'vue-markdown-render'
//import VueMarkdown from 'vue-markdown-v2';
//import { Vue2MarkdownIt  } from 'vue2-markdown-it'

//import VueMarked from 'vue-marked';

//import { marked } from 'marked';
//import marked from 'marked';

//import zDetail from '@/views/dialogs/details/VehiclePark'
/* import zDetail from '@/views/dialogs/details/VehiclePark2'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete' */

export default {
	name: 'VehicleEstimateAI',
	mixins: [mixin],
	components: {
		zParameters,
		zPdf,
	},
	data: () => ({
		title: 'Оцінка з ШІ',
		subtitle: 'Сервіс оцінки транспортних засобів за допомогою штучного інтелекту',
		icon: 'mdi-robot-happy',
		loading: false,

		filedata: null,

		promptCustom: null,

		snackbar: {
			visible: false,
			text: null
		},
	}),
	
	computed: {
		...mapGetters([ 'roles' ]),
		...mapGetters('VehicleEstimateAI', [ 'item' ]),

		isAdmin() {
			return this.roles.includes('ADMIN')
		},

		pdf() {
			return {
				datecreate: new Date(),
				title: this.title,
				filename: this.title,
				content: this.item.outputHtml
			}
		},

		prompt() {
			let 
				category = this.params?.category?.name,
				brand = this.params?.brand?.name,
				model = this.params?.model?.name,
				generation = this.params?.generation?.name,
				modification = this.params?.modification?.name,
				yearProd = this.params?.yearProd,
				driver = this.params?.driver?.name,
				fuel = this.params?.fuel?.name,
				gearbox = this.params?.gearbox?.name,
				color = this.params?.color?.name,
				state = this.params?.state?.name,
				city = this.params?.city?.name
			;

			let params = [];

			if(category) params.push(`категорія ${category}`)
			if(brand) params.push(`марка ${brand}`)
			if(model) params.push(`модель ${model}`)
			if(generation) params.push(`модель ${generation}`)
			if(modification) params.push(`модель ${modification}`)
			if(yearProd) params.push(`${yearProd} року випуску`)
			if(driver) params.push(`тип приводу ${driver}`)
			if(fuel) params.push(`тип палива ${fuel}`)
			if(gearbox) params.push(`коробка передач ${gearbox}`)
			if(color) params.push(`колір ${color}`)
			if(state) params.push(`область ${state}`)
			if(city) params.push(`місто ${city}`)

			let param = params.join(', ');

			let prompt = `Яка ринкова вартість автомобіля в Україні в доларах і гривнях з такими характеристиками: ${param}`;

			//let contents = "Яка ринкова вартість автомобіля BMW X5 2020 року випуску в Україні в доларах";

			//console.log(this.$options.name, 'getContent','contents', contents)

			//return prompt;
			return this.promptCustom ? this.promptCustom : prompt;
		}
	},

	methods: {
		showMessage(text, type) {
			this.snackbar.text 		= text;
			this.snackbar.visible 	= true;
			this.snackbar.color 	= null;
		},

		onPDF () {
			this.$refs.pdf.generate()
		},

		onClear() {
			this.$refs.parameters.reset()
		},

		onOK() {
			if(this.$refs.parameters.validate() || this.promptCustom) {
				this.find()
			}
		},

		find() {
			//console.log('App','gemini', 'GEMINI_API_KEY', process.env.VUE_APP_GEMINI_API_KEY)

			let text = this.prompt

			var that = this
			this.loading = true
			axios.post('/vehicle/estimate/ai', { text: text }).then(response => {
				//console.log(that.$options.name, 'onOK','response.data', response.data)
				that.item.outputHtml = response.data
			}, error => {
				console.log('error', error)
				//that.showMessage(error.response.data.message, 'error')
			}).finally(() => {
				this.loading = false
			});
		},

		/**
		 * Завантаження файлу
		 * Load JSON
		 */
		onLoad() {
			this.filedata = null
			this.$refs.filedata.$refs.input.click()
		},

		changeFileData (e) {
			const file = this.filedata;
			if (file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					try {
						const item = JSON.parse(e.target.result);

						//console.log(this.$options.name, 'changeFileData','item', item)

						this.setItem(item)
					} catch (error) {
						//console.error("Error parsing JSON:", error);
						//this.jsonData = null; // Clear data on error
						alert("Invalid JSON file.");
					}
				};

				reader.readAsText(file);
			} else {
				//this.jsonData = null; // Clear data if no file selected
			}
		},

		/**
		 * Збереження файлу Налаштувань
		 * Save JSON
		 */
		onSave() {
			//console.log(this.$options.name, 'onSave','item', this.item)
			const data = {
				params: this.params,
				item: this.item,
			}

			const filename = `${this.$options.name}.json`;
			const text = JSON.stringify(data);

			//console.log(this.$options.name, 'onSave','text', text)

			const blob = new Blob([text], { type: 'application/json' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		},
	},
}
</script>